import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { List } from 'immutable';
import { useTranslation } from 'react-i18next';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { View } from '@uncinc/react-drupal-core';

import { getVocabulary } from '../../../../store/actions/UI';
import ViewTypes from '../../../View/Types';

const VacanciesVolunteeringOverview = ({ display }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    dispatch(getVocabulary('volunteer_vacancy_types'));
  }, [dispatch]);

  const vacancyTerms = useSelector((state) => state.getIn(['uiInternal', 'vocabularies', 'volunteer_vacancy_types'], List()));

  return (
    <Container className="ParagraphContentOverview">
      <div className="MultipleFieldsFilter">
        <p>{t('vacancy.subject_filter')}</p>
        <ViewTypes
          entities={vacancyTerms}
          filterArray={filters}
          setFilterArray={setFilters}
          placeholder={t('vacancy.filter_placeholder')}
        />
      </div>

      <View
        id="content_overview"
        display={display}
        page={currentPage}
        setCurrentPage={setCurrentPage}
        type="vacancies_volunteering"
        filters={{ field_volunteer_vacancy_type_target_id: filters }}
      />
    </Container>
  );
};

export default VacanciesVolunteeringOverview;
